import React, { useState } from "react";
import { RiParentFill } from "react-icons/ri";
import { FaPhoneVolume, FaTransgenderAlt, FaLocationDot, FaEye } from "react-icons/fa";
import { MdEmail, MdBloodtype } from "react-icons/md";
import { GoNumber } from "react-icons/go";

const StudentModal = ({ student, isOpen, closeModal, onSave }) => {
  const [formData, setFormData] = useState({ ...student });
  const [imagePreview, setImagePreview] = useState(student.image || ""); // Track image preview

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagePreview(URL.createObjectURL(file)); // Preview the selected image
      setFormData((prev) => ({ ...prev, image: file })); // Store the image file in form data
    }
  };

  const handleSubmit = () => {
    onSave(formData);  // Pass updated form data to parent
    closeModal(); // Close the modal
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-1/2">
        <h3 className="text-xl font-semibold mb-4">Edit Student Profile</h3>
        <div className="space-y-4">
          {/* Image upload */}
          <div className="flex flex-col mb-4">
            <label className="mb-2">Student Image:</label>
            <input
              type="file"
              name="student_image"
              accept="image/*"
              onChange={handleImageChange}
              className="p-2 border border-gray-300 rounded"
            />
            {imagePreview && (
              <div className="mt-2">
                <img
                  src={imagePreview}
                  alt="Student Preview"
                  className="w-32 h-32 object-cover rounded-full"
                />
              </div>
            )}
          </div>

          {/* First row */}
          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="mb-2">First Name:</label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Last Name:</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          {/* Second row */}
          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Gender:</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Father's Name:</label>
              <input
                type="text"
                name="father_name"
                value={formData.father_name}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          {/* Third row */}
          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Mother's Name:</label>
              <input
                type="text"
                name="mother_name"
                value={formData.mother_name}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          {/* Fourth row */}
          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Mobile Number:</label>
              <input
                type="text"
                name="mobile_number"
                value={formData.mobile_number}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Parent Mobile Number:</label>
              <input
                type="text"
                name="parent_mobile_number"
                value={formData.parent_mobile_number}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          {/* Fifth row */}
          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Address:</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex flex-col w-1/2">
              <label className="mb-2">City:</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          {/* Sixth row */}
          <div className="flex gap-4">
            <div className="flex flex-col w-1/2">
              <label className="mb-2">State:</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="flex flex-col w-1/2">
              <label className="mb-2">Pincode:</label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                onChange={handleInputChange}
                className="p-2 border border-gray-300 rounded"
              />
            </div>
          </div>

          <div className="flex items-center justify-end space-x-4 mt-6">
            <button
              className="bg-gray-300 p-2 rounded-md"
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              className="bg-blue-500 text-white p-2 rounded-md"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentModal;
